import React, { Component } from 'react';
import { connect } from "react-redux";
import { loggedInUser } from '../../../redux/selectors'
import './animation.css';

import HappyLoggedIn from '../../assets/happyLoggedin.png';
import HappyLoggedOut from '../../assets/happyLoggedout.png';

class Animation extends Component {
  render() {
    const { user } = this.props;
    return (
      <div id='animation'>
        <img alt='happy' src={user && user.loggedIn ? HappyLoggedIn : HappyLoggedOut } />
      </div>
    )
  }
}

export default connect(state => ({user: loggedInUser(state)}))(Animation);
